/**
 * Summary stats bar for the Order list page.
 * Stats are filter-aware — they reflect current filters (except conversionStatus).
 *
 * Mỗi nhóm hiện SỐ ĐƠN + TIỀN HOÀN USER (cột "HH user"). Có tiền ở đây để đối
 * chiếu với file CSV: mở file → lọc theo trạng thái → SUM cột "HH user" → phải
 * ra đúng con số này.
 */
import { Tooltip } from "antd";

const fmtCount = (n) => Number(n || 0).toLocaleString("vi-VN");
const fmtMoney = (n) => Number(n || 0).toLocaleString("vi-VN") + "đ";

/** 1 ô: nhãn + số đơn + tiền hoàn user bên dưới. */
function StatItem({ label, count, money, className, first }) {
    return (
        <span className={`${className} ${first ? "" : "border-l pl-4"}`}>
            {label}: <strong>{fmtCount(count)}</strong>
            {money != null && (
                <Tooltip title="Tổng hoa hồng trả user (cột &quot;HH user&quot; trong file CSV)">
                    <span className="ml-1 text-xs opacity-80">· {fmtMoney(money)}</span>
                </Tooltip>
            )}
        </span>
    );
}

function OrderSummaryBar({ stats = {} }) {
    const { total = 0, pending = 0, completed = 0, cancelled = 0, money = {} } = stats;

    return (
        <div className="flex flex-wrap items-center gap-4 px-4 py-2 bg-surface rounded-lg border text-sm">
            <span className="text-content-3">
                Tổng: <strong className="text-content-2">{fmtCount(total)}</strong>
            </span>
            <StatItem label="Chờ duyệt" count={pending} money={money.pending?.user} className="text-orange-500" />
            <StatItem label="Đã duyệt" count={completed} money={money.completed?.user} className="text-green-600" />
            <StatItem label="Đã huỷ" count={cancelled} money={money.cancelled?.user} className="text-content-3" />
        </div>
    );
}

export default OrderSummaryBar;
